import { Current } from 'Types'

const { VARIABLES } = window

export default (): Current => ({
  accountId: VARIABLES.accountId,
  locationId: VARIABLES.locationId,
})
